// create a config defining types of share page modes
// for now we have one type where share page wil lbe show after listing is published

export const SHARE_PAGE_MODE_LISTING_PUBLISHED = 'listing_published';
export const SHARE_PAGE_MODES = [SHARE_PAGE_MODE_LISTING_PUBLISHED];
